import * as types from './types';
import * as api from './api';


export const dataFactoryList = customerid => ({
  type: types.dataFactoryList,
  payload: api.dataFactoryList(customerid)
});

export const dataFactoryTable = dataFactory => ({
  type: types.dataFactoryTable,
  payload: api.dataFactoryTable(dataFactory)
});

export const findByProjectName = projectName => ({
  type: types.findByProjectName,
  payload: api.findByProjectName(projectName)
});

export const toggleFile = (project, file) => ({
  type: types.TOGGLE_FILE,
  project,
  file
});

export const selectFile = (project, { fileId }) => ({
  type: types.SELECT_FILE,
  project,
  fileId
});

export const previewFile = ({ projectId }, file) => ({
  type: types.PREVIEW_FILE,
  payload: api.previewFile(projectId, file.fileId),
  meta: {
    projectId,
    file
  }
});

export const reviewFile = ({ projectId }, file) => ({
  type: types.REVIEW_FILE,
  payload: api.reviewFile(projectId, file.fileId),
  meta: {
    projectId,
    file
  }
});

export const filterFiles = id => ({
  type: types.FILTER_FILES,
  id
});

export const searchFiles = (projectId, searchTerm) => ({
  type: types.SEARCH_FILES,
  projectId,
  searchTerm
});

// export const translateFiles = projectId => ({
//   type: types.TRANSLATE_FILES,
//   payload: api.translateFiles(projectId),
//   meta: {
//     projectId
//   }
// });

export const translateFiles = (projectId, files) => ({
  type: types.TRANSLATE_FILES,
  payload: api.translateFiles(projectId, files),
  meta: {
    projectId,
    files
  }
});

export const viewReport = (projectId, reportId, fileId) => ({
  type: types.VIEW_REPORT,
  payload: api.viewReport(reportId, fileId),
  meta: {
    projectId,
    fileId
  }
});



// WEBPACK FOOTER //
// ./src/state/project/actions.js